import { Component, Input } from '@angular/core';

import { CaGroup } from '../../../core';
import { currentState } from '../../state';
import { State } from '../../state.model';
import { PhaseContentComponent } from '../phase-content/phase-content.component';

@Component({
    selector: 'cmps-ca-evaluation-phase-header',
    templateUrl: './phase-header.component.html',
})
export class PhaseHeaderComponent {
    @Input()
    group: CaGroup;

    @Input()
    ref: PhaseContentComponent;

    /** @private */
    _state: State;

    constructor() {
        this._state = currentState();
    }
}
